import { render, staticRenderFns } from "./MoreMobileMeals.vue?vue&type=template&id=64654534"
import script from "./MoreMobileMeals.vue?vue&type=script&lang=js"
export * from "./MoreMobileMeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports